import angular from 'angular'
import { statisticsSalesRank } from 'redevConfig'
const list = (statisticsSalesRank && statisticsSalesRank.list) || ''
const detail = (statisticsSalesRank && statisticsSalesRank.detail) || ''

const statisticsSalesRankList = list ? require(`redevelopment/statistics/statisticsSalesRank/${list.templateName}`) : require('./view/statisticsSalesRankList.html')
const statisticsSalesRankListCtrl = list ? require(`redevelopment/statistics/statisticsSalesRank/${list.controllerName}`) : require('./statisticsSalesRankListCtrl')

const statisticsSalesRankDetail = detail ? require(`redevelopment/statistics/statisticsSalesRank/${detail.templateName}`) : require('./view/salesRankDetail.html')
const statisticsSalesRankDetailCtrl = detail ? require(`redevelopment/statistics/statisticsSalesRank/${detail.controllerName}`) : require('./statisticsSalesRankDetailCtrl')
export default angular
    .module('app.statisticsSalesRank', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.outputStatistics.statisticsSalesRank', {
                abstract: true,
                url: '/statisticsSalesRank',
                template: '<div ui-view></div>',
                title: '销售额排名',
                default: 'statistics.outputStatistics.statisticsSalesRank.list',
            })
            .state('statistics.outputStatistics.statisticsSalesRank.list', {
                url: '/list',
                template: statisticsSalesRankList,
                controller: 'statisticsSalesRankListCtrl',
            })
            .state('statistics.outputStatistics.statisticsSalesRank.detail', {
                url: '/detail/:params/:type',
                template: statisticsSalesRankDetail,
                controller: 'statisticsSalesRankDetailCtrl',
                title: '排名详情',
            })
    }])
    .controller('statisticsSalesRankListCtrl', statisticsSalesRankListCtrl.default)
    .controller('statisticsSalesRankDetailCtrl', statisticsSalesRankDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsSalesRank/index.js